import type { HTMLAttributes, PropsWithChildren } from "react";

import { TIconKey } from "../Icon";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const PILL_VARIANT_CLASS_MAP = {
  price: "border-component-pill-price bg-component-pill-price text-foreground",
  benefit: "border-component-pill-benefit bg-component-pill-benefit text-foreground",
} as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TPillVariant = keyof typeof PILL_VARIANT_CLASS_MAP;

export type TPillProps = {
  variant: TPillVariant;
  icon?: TIconKey;
} & PropsWithChildren & HTMLAttributes<HTMLDivElement>;


/* Boilerplate  */
// type TPillDefaultProps = DefinedDefaults<TPillProps, {required-default }>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const PILL_DEFAULTS = {

}; // satisfies TPillDefaultProps;
